module.exports = __webpack_public_path__ + "static/img/pic1.c165a13.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case4/pic1.jpg
// module id = 5/Uf
// module chunks = 1